import { Component, OnInit } from "@angular/core";
import { NgForm } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import Swal from "sweetalert2";
import { GrupoPermissaoService } from "@core/services/grupo-permissao.service";
import { AuthenticationService } from "app/auth/service";

@Component({
	selector: "app-form-grupo-permissao",
	templateUrl: "./form-grupo-permissao.component.html",
	styleUrls: ["./form-grupo-permissao.component.scss"],
})
export class FormGrupoPermissaoComponent implements OnInit {
	public tipo;
	public href;

	public contentHeader: object;
	private routeSub: Subscription;

	public componentId: number;
	public isLoading = false;

	constructor(private route: ActivatedRoute) { }

	public submitForm(data: NgForm) {
		if (data.form.valid === true) {
			this.isLoading = true;
			// this.indicadorService.indicadorPut(data, this.componentId).subscribe(
			//   (res) => {
			//     this.isLoading = false;
			//     Swal.fire({
			//       title: "Sucesso!",
			//       text: "O item foi atualizado.",
			//       icon: "success",
			//       confirmButtonText: "Confirmar",
			//     }).then((result) => {
			//       if (result.isConfirmed) {
			//         location.href = "/grupo-permissao";
			//       }
			//     });
			//   },
			//   (error) => {
			//     Swal.fire("Erro!", "Ocorreu um erro ao cadastrar.", "error");
			//   }
			// );
		}
	}

	ngOnInit() {
		this.href = this.route.url;
		// this.indicadorService.gruposIndicadorGet().subscribe(
		//   (res) => (this.grupo_indicadores = res),
		//   (error) => error
		// );

		// this.routeSub = this.route.params.subscribe((params) => {
		//   this.indicadorService.indicadorGetById(params["id"]).subscribe(
		//     (res) => {
		//       this.componentId = params["id"];
		//       this.nomeModel = res[0].nome;
		//     },
		//     (error) => error
		//   );
		// });
		if (this.href.value[1].path == "cadastro") {
			this.contentHeader = {
				headerTitle: "Cadastrar Permissões",
				actionButton: false,
				breadcrumb: {
					type: "",
					links: [
						{
							name: "Início",
							isLink: false,
						},
						{
							name: "Grupo de Permissão",
							isLink: false,
						},
						{
							name: "Cadastro",
							isLink: false,
						},
					],
				},
			};
		}

		if (this.href.value[1].path == "editar") {
			this.contentHeader = {
				headerTitle: "Editar Permissões",
				actionButton: false,
				breadcrumb: {
					type: "",
					links: [
						{
							name: "Início",
							isLink: false,
						},
						{
							name: "Grupo Permissão",
							isLink: false,
						},
						{
							name: "Editar",
							isLink: false,
						},
					],
				},
			};
		}
	}

	// ngOnDestroy() {
	//   this.routeSub.unsubscribe();
	// }
}
